var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTakeAway(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 87,
    height: 75,
    viewBox: "0 0 87 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "take-away",
    transform: "translate(-751 -1379)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_15",
    "data-name": "Subtraction 15",
    d: "M9.757,19h0L0,19V10A10.011,10.011,0,0,1,10,0H25A10.011,10.011,0,0,1,35,10v9H25.244a5,5,0,0,0,1.192-3.241V12.389a5.006,5.006,0,0,0-5-5H13.564a5.006,5.006,0,0,0-5,5v3.369A5,5,0,0,0,9.756,19Z",
    transform: "translate(777 1379)",
    fill: "#26c165"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1460",
    "data-name": "Rectangle 1460",
    width: 87,
    height: 59,
    rx: 5,
    transform: "translate(751 1395)",
    fill: "#b0ffd0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2752",
    "data-name": "Path 2752",
    d: "M1.89-76.666V-80.44H4.87v-9.886h6.841l4.761,9.886h5.6v-9.886h5.811v9.886h3.238v3.774H27.879v2.252h3.238v3.774H27.879v11.065h-6.39L16.021-70.64H10.682v11.065H4.87V-70.64H1.89v-3.774H4.87v-2.252Zm17.5,2.252h2.68v-2.252H18.294Zm-8.706,0h3.5l-1.115-2.252h-2.38ZM22.154-68.56h.064q-.086-.729-.129-2.08h-.858Q21.7-69.632,22.154-68.56ZM10.617-82.005h-.086q.043.686.086,1.565h.622Q10.982-81.083,10.617-82.005Z",
    transform: "translate(778.111 1500.325)",
    fill: "#25be63"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakeAway);
export default __webpack_public_path__ + "static/media/take-away.8972ef4df4b69a3667fc73f0659ced42.svg";
export { ForwardRef as ReactComponent };